import React, { memo } from 'react'
import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons'

import FailedStatus from '../common/FailedStatus'
import customConfig from 'customConfig'

const CodeTooManyTries = ({ onSubmit, t }) => (
  <FailedStatus
    title={t('reward.too-many-tries')}
    description={t(customConfig.triedTooManyTimesLabel)}
    icon={faExclamationCircle}
    onSubmit={onSubmit}
    t={t}
  />
)

export default memo(CodeTooManyTries)
